import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import swal from 'sweetalert'
import { Button, Glyphicon } from 'react-bootstrap'
import ReactQuill from 'react-quill'

import { handleErrorFetchingData } from '../../functions/errorHandling'
import { parseTitleFromHtml } from '../../functions/reactQuillHandling'
import getServerURL from '../../functions/getServerURL'


import Update from './Update'

class Updates extends Component {

  state = {
    newUpdate: "",
    savingUpdate: false,
  }

  handleStatusInput = (newUpdate) => this.setState({ newUpdate })

  handlePost = () => {
    const { currentUser, parentElement, parentElementName, route } = this.props
    const { newUpdate, savingUpdate } = this.state

    if (!newUpdate || newUpdate === '<p><br></p>') {
      return swal({
        title: "Error",
        text: `Please enter text in the update field before saving`,
        icon: "error",
        button: "Continue",
      })
    }

    if (savingUpdate) {
      return
    }

    this.setState({ savingUpdate: true })

    const formattedName = parseTitleFromHtml(newUpdate, 100)

    axios({
      method: "POST",
      url: `${getServerURL()}${route}/`,
      data: {
        created_by: currentUser.url,
        name: formattedName,
        body: newUpdate,
        [parentElementName]: parentElement.url
      },
      headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
    })
    .then(response => {
      let update = response.data
      const created_by = {...currentUser, id: currentUser.pk}
      update = {...update, created_by}
      this.props.addUpdate(update)
  	  this.setState({ newUpdate: "", savingUpdate: false })
    })
    .catch(error => {
      this.setState({ savingUpdate: false })
      const message = "There was an error adding your update."
      handleErrorFetchingData(error, message)
    })
  }

  render () {
    const { parentElement } = this.props

    const sortedUpdates = parentElement.updates.sort((a,b) => {
      return new Date(b.created_date).getTime() - new Date(a.created_date).getTime()
    })

    return (
      <div id="ProjectUpdates">
        <ReactQuill
          value={this.state.newUpdate}
          theme="snow"
          placeholder="Enter update..."
          readOnly={this.state.savingUpdate}
          onChange={this.handleStatusInput}
        />
        <br/>
        <Button
          bsStyle="primary"
          onClick={this.handlePost}
          disabled={this.state.savingUpdate}
        >
          {this.state.savingUpdate ?
            <Glyphicon
              glyph='refresh'
              style={{minWidth: '28px'}}
              className='rotate-btn'
            />
            :
            'Post'
          }
        </Button>

        {sortedUpdates.length > 0 ?
          <Fragment>
            <center>
              <h4>Updates</h4>
            </center>
            {sortedUpdates.map(update => {
              return (
                <Update
                  key={update.id}
                  update={update}
                  deleteUpdate={this.props.deleteUpdate}
                  editUpdate={this.props.editUpdate}
                />
              )
            })}
          </Fragment>
          :
          null
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.manageLogin.user,
  }
}

export default connect(mapStateToProps)(Updates);



// WEBPACK FOOTER //
// ./src/reuseable-components/updates/Updates.js